const classAnnouncementDetails = {
  path: 'classAnnouncementDetails/:classAnnouncementId',
  component: resolve => require(['../../../../components/pages/student_user/classAnnouncementDetails'], resolve),
  props: true
}
export default classAnnouncementDetails



// WEBPACK FOOTER //
// ./src/router/pages/student_user/classAnnouncementDetails/index.js